import * as React from 'react';
import { ReactNode } from 'react';
import {
  OrganisationInstitutionalIdDTO,
  PersonInstitutionalIdDTO,
  ProjectInstitutionalIdDTO,
} from '../../../api/core';
import { InlineIcon } from '../../components/InlineIcon';
import { getMandantSettingsByMandant } from '../../../util/mandant-settings-utils';
import { ExternalIdEntityType, MandantSettings } from '../../../util/types';
import { CustomBadge } from '../../components/CustomBadge';

interface Props {
  id: ProjectInstitutionalIdDTO | PersonInstitutionalIdDTO | OrganisationInstitutionalIdDTO;
  entity: ExternalIdEntityType;
}

export const InstitutionalId = (props: Props): ReactNode => {
  if (!props.id?.institution) return props.id.value;
  const ms: MandantSettings = getMandantSettingsByMandant(props.id.institution) || null;
  return <div className={'flex py-1'}>
    <CustomBadge
      label={props.id.value}
      images={ms?.icon ? <InlineIcon src={ms.icon} alt={`${props.id.institution} Icon `}/> : undefined}
      alt={props.id.institution}
    />
  </div>;
};
